import React from 'react';

function TrinidadAndTobago(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123975)">
        <mask
          id="mask0_800_123975"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123975)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask1_800_123975"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123975)">
            <path
              d="M33.1587 29.494L32.6229 29.8835L32.1696 29.4533L-1.96753 -2.94541L-2.58511 -3.53155L-1.85511 -4.06223L1.62828 -6.59455L2.16411 -6.98408L2.61743 -6.55385L36.7545 25.8448L37.3721 26.431L36.6421 26.9617L33.1587 29.494Z"
              fill="#272727"
              stroke="#F7FCFF"
              strokeWidth="1.5"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123975">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TrinidadAndTobago;
